export const VALIDATIONS = {
    NAME: 50,
    PHONE_MIN: 10,
    PHONE_MAX: 16,
    BIO_MAX: 255,
    EMAIL: 255,
    PASSWORD_MIN: 8,
    PASSWORD_MAX: 32,
    VERIFICATION_CODE: 5,
    CARD_NUMBER: 16,
    CVV: 3,
    TEAM_TITLE_MAX: 50,
    NOTIFICATION_TITLE_MAX: 50,
    NOTIFICATION_DESCRIPTION_MAX: 255,
    LOCATION_MAX: 255,
    CAPTION_MAX: 255,
    GROUP_TITLE: 32,
    LESSON_TITLE: 32,
    SESSION_TITLE: 32,
    ADDRESS_MAX: 200,
}

export const VALIDATIONS_TEXT = {
    SESSION_TITLE_REQUIRED: "Session title is required",
    ORGANIZATION_NAME_REQUIRED: "Organization name is required",
    NAME_REQUIRED: "Name is required",
    GROUP_TITLE_REQUIRED: "Title is required",
    LESSON_TITLE_REQUIRED: "Title is required",
    EMAIL_REQUIRED: "Email is required",
    EMAIL_FORMAT: "Invalid email format",
    PASSWORD_REQUIRED: "Password is required",
    CONFIRM_PASSWORD_REQUIRED: "Confirm password is required",
    CURRENT_PASSWORD_REQUIRED: "Current Password is required",
    NEW_PASSWORD_REQUIRED: "New Password is required",
    PHONE_REQUIRED: "Contact number is required",
    TEAM_TITLE_REQUIRED: "Team title is required",
    NOTIFICATION_TITLE_REQUIRED: "Notification title is required",
    NOTIFICATION_DESCRIPTION_REQUIRED: "Notification description is required",
    PAGE_CONTENT_REQUIRED: "Page Content is required",
    ADDRESS_REQUIRED: "Address is required",


    SESSION_TITLE_MAX: "Max length is " + VALIDATIONS.SESSION_TITLE,
    GROUP_TITLE_MAX: "Max length is " + VALIDATIONS.GROUP_TITLE,
    LESSON_TITLE_MAX: "Max length is " + VALIDATIONS.GROUP_TITLE,
    NAME_MAX: "Max length is " + VALIDATIONS.NAME,
    EMAIL_MAX: "Max length is " + VALIDATIONS.EMAIL,
    PASSWORD_MIN: "Min length is " + VALIDATIONS.PASSWORD_MIN,
    PASSWORD_MAX: "Max length is " + VALIDATIONS.PASSWORD_MAX,
    CARD_NUMBER_MIN: "Min length is " + VALIDATIONS.CARD_NUMBER,
    CARD_NUMBER_MAX: "Max length is " + VALIDATIONS.CARD_NUMBER,
    PHONE_MIN: "Min length is " + VALIDATIONS.PHONE_MIN,
    PHONE_MAX: "Max length is " + VALIDATIONS.PHONE_MAX,
    BIO_MAX: "Max length is " + VALIDATIONS.BIO_MAX,
    CVV_MIN: "Min length is " + VALIDATIONS.CVV,
    CVV_MAX: "Max length is " + VALIDATIONS.CVV,
    TEAM_TITLE_MAX: "Max length is " + VALIDATIONS.TEAM_TITLE_MAX,
    NOTIFICATION_TITLE_MAX: "Max length is " + VALIDATIONS.NOTIFICATION_TITLE_MAX,
    NOTIFICATION_DESCRIPTION_MAX: "Max length is " + VALIDATIONS.NOTIFICATION_DESCRIPTION_MAX,
    LOCATION_MAX: "Max length is " + VALIDATIONS.LOCATION_MAX,
    CAPTION_MAX: "Max length is " + VALIDATIONS.CAPTION_MAX,
    ADDRESS_MAX: "Max length is " + VALIDATIONS.ADDRESS_MAX,
    VERIFICATION_CODE: "Length is " + VALIDATIONS.VERIFICATION_CODE,
    INVALID_FORMAT: "Invalid format",

}

export const SPECIAL_CHARACTER_ARRAY = [
    "~", "`", "!", "@", "#", "$", "%", "^", "&", "*", "(", ")", "-", "_", "+", "=", "{", "}", "[", "]", ";", ":", "'", '"', "\\", "|", "<", ",", ">", ".", "?", "/"
]

export const SPECIAL_CHARACTER_ARRAY_FOR_ADDRESS = [
    "~", "`", "!", "@", "#", "$", "%", "^", "&", "*", "(", ")", "_", "+", "=", "{", "}", "[", "]", ";", ":", "'", '"', "\\", "|", "<", ">", ".", "?", "/"
]

export const CHARACTER_ARRAY_FOR_NUMBER_INPUT = [
    "e", "E", "-", "+", "."
]
